import axios from '@axios';
import store from '@/store';

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(event => ({
        value: event.code,
        label: event.description,
        related_events: event.related_events
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const response = await axios.get('v1/dmp/logs', {
        params,
        responseType: params?.action === 'export' ? 'blob' : 'json'
      })

      if (!response.data) {
        return []
      }

      if (params?.action === 'export') {
        const disposition = response.headers['content-disposition'] || ''
        const filename = disposition.includes('filename=')
          ? disposition.split('filename=')[1].replace(/['"]/g, '')
          : 'dmp_logs.xlsx'
        const url = window.URL.createObjectURL(new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }))
        const link = document.createElement('a')

        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        link.remove()

        store.dispatch('grid/updateDownloadNotification', {
          id: filename,
          progress: 100,
          completed: true,
          view: 'DMP Logs',
          url,
          download: filename,
          title: 'Reporte de DMP Logs',
          body: 'Descarga completa',
          error: false,
          timestamp: `${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`
        })

        return response.data
      }

      commit('setData', response.data.data)
      return response.data
    },
    clear({ commit }) {
      commit('setData', [])
    }
  },
}
